export const HELP_LOADING_START = 'HELP/LOADING_START';
export const HELP_DATA_LOADING_START = 'HELP/DATA_LOADING_START';
export const HELP_LOADING_END = 'HELP/LOADING_END';
export const HELP_DATA_LOADING_END = 'HELP/DATA_LOADING_END';
export const HELP_GET_FEEDBACK = 'HELP/GET_FEEDBACK';
export const HELP_CREATE_FEEDBACK = 'HELP/CREATE_FEEDBACK';
export const HELP_FEEDBACK_NEW_MESSAGE = 'HELP/NEW_FEEDBACK_MESSAGE';
